// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import type { HttpClientInstance } from '@toggl/sync/http';
import type { HandlersMeResponse } from '../types';

export async function getMe(
  httpClient: HttpClientInstance,
  signal?: AbortSignal
) {
  const response = await httpClient
    .get(`me`, { signal })
    .json<HandlersMeResponse>();
  return response;
}
